import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { GET_CARS_LIST_OF_VENDOR, GET_CARS_LIST_OF_VENDOR_ERROR, GET_CARS_LIST_OF_VENDOR_SUCCESS } from '../../../actions.js';

function* getCarsListOfVendor({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/cars`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.params,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CARS_LIST_OF_VENDOR_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CARS_LIST_OF_VENDOR_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CARS_LIST_OF_VENDOR_ERROR, payload: error });
  }
}

export function* watchGetCarsListOfVendor() {
  yield takeEvery(GET_CARS_LIST_OF_VENDOR, getCarsListOfVendor);
}

function* getCarsListOfVendorSaga() {
  yield all([fork(watchGetCarsListOfVendor)]);
}

export default getCarsListOfVendorSaga;
